

import SettingBase from '../settings/util/SettingBase'

class DeliveryRegionRoutingController extends SettingBase {
    /*@ngInject*/
    constructor($state) {
        super();
        this.acl = {};
        this.hasACL = {};
        this.id = 'delivery-region-routing';
        this.$state = $state;
    }

    $onInit() {
        super.$onInit();
        for (let key in this.acl['setting-delivery-region-routing']) {
            this.hasACL[this.acl['setting-delivery-region-routing'][key]] = true;
        }
    }
}

export default DeliveryRegionRoutingController;


// WEBPACK FOOTER //
// ./client/app/components/delivery_region_routing/delivery_region_routing.controller.js